import React from 'react';
import { Dialog } from "primereact/dialog";
import GenericTable from "../SocioDemografia/GenericTable/GenericTable";
import DataTable from "./DataTable";
import GenericDataFormatter from "../SocioDemografia/GenericTable/GenericDataFormatter";
import LinkagesDataLayerService from "../../services/LinkagesDataLayer/LinkagesDataLayerService";
import getLabel from '../../services/LinkagesDataLayer/labels';


class LinkagesDataTableModal extends React.Component {

    constructor(props) {
        super(props);
    }

    useGenericTable(datalayerName) {
        return [
            'populacao', 'domicilios', 'populacao_domicilios', 'renda_consumo',
            'renda', 'consumo', 'indice_propriedade', 'consumo_valor', 'consumo_porcentagem'
        ].includes(datalayerName);
    }

    render() {
        let formatter = null;

        const title = LinkagesDataLayerService.getLayerLabel(this.props.activeDatalayer);

        if (this.useGenericTable(this.props.activeDatalayer)) {
            const config = this.getFormatterConfig(title);
            formatter = new GenericDataFormatter(this.props.data, this.props.overlays, config);
        }

        return (
            <React.Fragment>
                <Dialog header={title}
                    visible={this.props.visible}
                    style={{
                        width: '60vw',
                        marginTop: '30px'
                    }} onHide={this.props.onHide}>
                    <div className="card" style={{
                        maxHeight: '75vh',
                        minHeight: '50vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        marginBottom: '20px'
                    }}>
                        <div className="card-body" style={{ overflowX: 'scroll' }}>
                            {this.useGenericTable(this.props.activeDatalayer) && formatter && <React.Fragment>
                                <GenericTable
                                    formatter={formatter}
                                    overlays={this.props.overlays}
                                />
                            </React.Fragment>}

                            {!this.useGenericTable(this.props.activeDatalayer) && <React.Fragment>
                                <DataTable
                                    data={this.props.data}
                                    activeDatalayer={this.props.activeDatalayer}
                                />
                            </React.Fragment>}
                        </div>
                    </div>
                </Dialog>
            </React.Fragment>
        );
    }

    getFormatterConfig(title) {
        const config = {
            dados: {},
            data_label: "",
            title: title,
            uses_subheader: true,
            datalayerName: this.props.activeDatalayer
        }

        if (this.props.data && this.props.data.length > 0) {
            const dadosArray = Object.keys(this.props.data[0]);

            dadosArray.forEach((datum) => {
                if (datum !== 'shape_id' && datum !== 'nome') {
                    config.dados[datum] = getLabel(datum)
                }
            });
        }


        return config;
    }
}

export default LinkagesDataTableModal;
